import { Link, Typography } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useGlobalization } from '@Translations/useGlobalization';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const NoReasultsRisk = ({
	adminFullAccess,
	configId,
}: {
	adminFullAccess: boolean;
	configId: string;
}) => {
	const { t } = useGlobalization();
	const history = useHistory();

	const lofClicked = () => {
		history.push('/risk/lofSetup/' + configId);
	};

	const cofClicked = () => {
		history.push('/risk/cofSetup/' + configId);
	};

	const riskClicked = () => {
		history.push('/risk/riskSetup/' + configId);
	};

	return (
		<>
			{adminFullAccess ? (
				<>
					<p>
						<Typography variant="caption">
							{t(
								'To generate model results, you will first need to configure your risk model and run it.',
							)}
						</Typography>
					</p>
					<p>
						<Typography variant="caption">
							{t('Risk models consist of ')}
							<Link
								underline="hover"
								style={{
									cursor: 'pointer',
									width: '100%',
									whiteSpace: 'nowrap',
								}}
								title={t('Likelihood of Failure')}
								onClick={() => {
									lofClicked();
								}}
								data-cy="lofLink">
								{t('Likelihood of Failure')}
							</Link>
							{', '}
							<Link
								underline="hover"
								style={{
									cursor: 'pointer',
									width: '100%',
									whiteSpace: 'nowrap',
								}}
								title={t('Consequence of Failure')}
								onClick={() => {
									cofClicked();
								}}
								data-cy="cofLink">
								{t('Consequence of Failure')}
							</Link>
							{t(', and ')}
							<Link
								underline="hover"
								style={{
									cursor: 'pointer',
									width: '100%',
									whiteSpace: 'nowrap',
								}}
								title={t('Risk Setup')}
								onClick={() => {
									riskClicked();
								}}
								data-cy="riskLink">
								{t('Risk Setup')}
							</Link>
							{t(' configuration')}
						</Typography>
					</p>
					<p>
						<Typography variant="caption">
							{t('You can create these in any order.')}
						</Typography>
					</p>
				</>
			) : (
				[]
			)}
		</>
	);
};
